import React from 'react'
import vector from "../assets/Vector.webp"
import logo from "../assets/footer-logo.webp"
import { Link } from 'react-router-dom'
import { useSelector, useDispatch } from "react-redux";
import { privacySwitch,termSwitch, cookieSwitch } from '../reducers/ToggleAction';

function Footer(){

    
    function handleClick(){
        window.scrollTo(0, 0);
    }
    
    const dispatch = useDispatch();
    return (
        <div id='footer' className='px-20 pt-16'>
            <div className='flex items-start justify-center px-12'>
                <h2 style={{ color: "#FBC213" }} className='border-l-0'>A PROMISING 360 <br /> 
                <span
                style={{marginLeft:"-1.5rem"}} 
                >ADVERTISEMENT <span style={{marginLeft:"-.5rem"}}>AGENCY</span></span></h2>
            </div>

            <div id='footer-content' className='flex text-white justify-center my-16 mx-12'>
               
                <div className='footer-sec'>
                    <div>Quick Links</div>
                    <p onClick={()=>handleClick()}><Link to="/">Home</Link></p>
                    <p onClick={()=>handleClick()}><Link to="/about">About</Link></p>
                    <p onClick={()=>handleClick()}><Link to="/services">Services</Link></p>
                    <p onClick={()=>handleClick()}><Link to="project">Projects</Link></p>
                    <p onClick={()=>handleClick()}><Link to="/contact">Contact</Link></p>
                </div>
                <div className='footer-sec'>
                    <div>Legal</div>
                    <p onClick={()=> dispatch(termSwitch())}>Terms & Conditions</p>
                    <p onClick={()=> dispatch(privacySwitch())}>Privacy Policy</p>
                    <p onClick={()=> dispatch(cookieSwitch())}>Cookie Policy</p>
                </div>
                <div className='footer-sec'>
                    <div>Social Media</div>
                    <a target='blank' href='https://www.facebook.com/Vwrap.pk?mibextid=ZbWKwL'>
                    <p>Facebook</p>
                    </a>
                    <p>Twitter</p>
                    <a target='blank' href='https://www.linkedin.com/company/vwrap/'>
                    <p>LinkedIn</p>
                    </a>
                </div>
                <div className='footer-sec'>
                    <div>Contact</div>
                    <p>info@vwrap.pk</p>
                    <p>+92 300 283 7111</p>
                    <p>R-96, Gulshan E Iqbal,<br/> Block 06, Karachi</p>
                    
                </div>
            </div>
 
          <div id='footer-sec-2' className='flex items-start justify-between mx-16 my-20'>
            <div className='border-t py-4'>
              <img src={logo} width={"300px"} alt='vwrap'/>
            </div>

            <p className='text-white w-2/5 border-t p-4 mr-2'>
Thank you for considering Vwrap for your outdoor marketing needs. Contact us today to learn more about our services and how we can help your brand make a big impact in the great outdoors.</p>
          </div>
       
        <div className='flex justify-center'>
         <span className='py-6 text-white text-center border-t w-2/3'>
         All rights reserved - 2023
         </span>
        </div>

        </div>
    )
}

export default Footer
